import makeStyles from '@mui/styles/makeStyles'

export const ANIMATION_DURATION = 1250

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    borderRadius: '100rem',
    minWidth: 'calc(1.2rem - 10px)',
    height: '1.2rem',
    backgroundColor: theme.palette.primary.main,
    paddingInline: '5px',

    '& > div': {
      margin: '0 auto',
      fontSize: theme.size.sm,
      color: 'white'
    }
  },

  blinkRoot: {
    animation: `$blink ${ANIMATION_DURATION}ms infinite`
  },

  '@keyframes blink': {
    '0%': {
      boxShadow: `${theme.palette.notification.dot} 0 0 0 0`
    },
    '75%': {
      boxShadow: `${theme.palette.notification.dot}00 0 0 0 12px`
    }
  }
}))

export default useStyles
